<template>
  <div class="volumes">
    <i class="fa fa-edit"
       @click="dialogObject = true"
    />
    <el-dialog
      width="90%"
      :title="`Hастройка плана ${type === 'JOB' ? 'работ' : type} по дням (сменам)`" :visible.sync="dialogObject">
      <div class="volumes">
        <div style="display: flex; justify-content: flex-start" v-if="plan"
        >
          <VolumeMultiple
            :type="type"
            :name="name"
            :propsValue="plan"
            :plan-row="tableData"
            @applyForAll="(a) => setVolumesAll(a)"
            :currentMonth="currentMonth"
          >
            <el-button size="mini" type="default" style="width: 140px; margin-bottom: 10px">
              Распределить
            </el-button>
          </VolumeMultiple>
        </div>
        <el-table
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Наименование"
            :width="130">
            <template slot-scope="scope">
              <div v-if="scope.$index !== 0" style="display: flex; align-items: center">
                <VolumeMultiple
                  :type="type"
                  :name="name"
                  @apply="(a) => setVolumes(a, scope.$index)"
                  :currentMonth="currentMonth"
                  :index="scope.$index"
                  :planRow="scope.row"
                />
                <strong style="padding-left: 10px">
                  Смена {{ scope.$index }}</strong>
              </div>
              <strong v-else>
                <strong>{{ jobName }}</strong>
              </strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="Итого объемы на месяц"
            width="135">
            <template slot-scope="scope">
              <strong v-if="scope.$index === 0">{{ getTotalSum(scope.$index) }}</strong>
              <strong v-else-if="type === 'JOB' || scope.$index === 0">{{ getTotalSum(scope.$index) }}</strong>
              <el-input v-else v-model="scope.row.all" @blur="(v) => scope.row.all = formatNumber(scope.row.all)"/>
            </template>
          </el-table-column>
          <el-table-column
            v-for="date in dates"
            :key="date"
            :prop="date"
            :label="date"
            width="150">
            <template slot-scope="scope">
              <div v-if="scope.$index !== 0">
                <el-input :value="scope.row[date]" @input="(v) => scope.row[date] = v.replace(',', '.')"
                          @blur="(v) => scope.row[date] = formatNumber(scope.row[date])"/>
              </div>
              <strong v-else>
                {{ getSummaryByDate(date) }}
              </strong>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="create-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import _ from 'lodash';
import VolumeMultiple from "./VolumeMultiple";
import {toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";
import {getCurrentMonth} from "../../../../utils/date";

export default {
  name: "Volumes",
  components: {VolumeMultiple},
  props: {
    jobName: "",
    table: [Object, Array],
    type: String,
    plan: [Number, String]
  },
  data() {
    return {
      dialogObject: false,
      tableData: [{
        total: this.$route.query.name,
      }],
      dates: [],
      months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль",
        "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        if (table.length) {
          setTimeout(() => {
            this.tableData = [
              {...this.tableData[0]},
              ...table.map((t) => {
                return t || this.tableData[1]
              })
            ]

          }, 100)
        }
      }
    }
  },
  methods: {
    setVolumesAll(tableData) {
      this.tableData = [...tableData]
      this.save()
    },
    formatNumber(v) {
      return toFloat(v)
    },
    formatValue(value) {
      return toFixedWithoutZero(value)
    },
    setVolumes(d, index) {
      this.tableData[index] = d
      this.tableData = [...this.tableData]
    },
    save() {
      const result = [];

      this.tableData.forEach((data, index) => {
        if (index) {
          result.push(data)
        }
      })

      const total = this.getTotalSum()

      this.$emit('save', {
        table: result,
        total
      })

      this.dialogObject = false;
    },
    getSummaryByDate(day) {
      let total = 0;

      this.tableData.forEach((data, index) => {
        if (index) {
          try {
            total += Number(data[day])
          } catch (e) {
          }
        }
      })
      return toFixedWithoutZero(total)
    },
    getTotalSum(index) {
      let total = 0;

      if (this.type !== 'JOB') {
        let total = 0;

        this.tableData.forEach((d, index) => {
          if (index) {
            total += Number(d.all || 0)
          }
        })

        return toFixedWithoutZero(total)
      }

      if (!index) {
        this.dates.forEach((d) => {
          total += this.getSummaryByDate(d)
        })

        const result = toFixedWithoutZero(total)

        if (this.plan) {
          const diff = total - this.plan;
          return (diff < 0.001 && diff > -0.001) ? this.plan : result
        }

        return result
      }

      this.dates.forEach((d) => {
        try {
          total += Number(this.tableData[index][d])
        } catch (e) {
        }
      })

      const result = toFixedWithoutZero(total)
      if (this.plan) {
        const diff = total - this.plan;
        return (diff < 0.001 && diff > -0.001) ? this.plan : result
      }

      return result
    },
  },
  computed: {
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  },
  mounted() {
    const name = this.$route.query.name;

    if (!name) {
      return
    }

    const year = name.split('-')[1]

    const monthNumber = this.currentMonth
    const daysInMonth = dayjs(`${year}-${monthNumber}-01`).daysInMonth();
    let nums = _.range(1, daysInMonth + 1);

    const tableRow = {};

    this.dates = nums.map((n) => {
      const date = dayjs(`${year}-${monthNumber}-${n}`).format('DD.MM.YYYY');
      tableRow[date] = ''
      return date
    })


    this.tableData = [
      {...tableRow, all: null},
      {...tableRow, all: null},
      {...tableRow, all: null},
      {...tableRow, all: null},
    ]
  }
}
</script>

<style scoped lang="scss">
.volumes {
  max-width: 95%;
  margin: 0 auto;
}

.create-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/Volumes.vue